import React from 'react';
import PropTypes from 'prop-types';

function FormPreview(props) {
  let iframeOrLoadingText = <h4 className="text-center preview-loading-text">Loading form preview...</h4>;

  if (props.isAuthorized) {
    iframeOrLoadingText = (
      <iframe
        title="Taxi Form Preview"
        style={{
          height: '100vh',
          width: '100%',
          border: 'none',
        }}
        src={`/api/v1/preview/${props.formId}${props.version ? `/?version=${props.version}` : ''}`}
      />
    );
  }
  return (
    <div style={{ maxWidth: '90vw', margin: 'auto' }} className="mt-5">
      {iframeOrLoadingText}
    </div>
  );
}
FormPreview.propTypes = {
  formId: PropTypes.string.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  version: PropTypes.string,
};

export default FormPreview;
